import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [class]="getContainerClasses()" *ngIf="loading">
      <div [class]="getSpinnerClasses()"></div>
      <span *ngIf="text" class="mt-2 text-sm text-slate-600">{{ text }}</span>
    </div>
  `
})
export class LoaderComponent {
  @Input() overlay: boolean = true;
  @Input() text?: string;
  @Input() size: 'sm' | 'base' | 'lg' = 'base';
  @Input() loading: boolean = false;

  getContainerClasses(): string {
    return this.overlay
      ? 'absolute inset-0 bg-white/70 flex flex-col items-center justify-center z-50'
      : 'flex flex-col items-center justify-center';
  }

  getSpinnerClasses(): string {
    const baseClasses = 'animate-spin rounded-full border-b-2 border-primary-600';

    const sizeClasses = {
      sm: 'h-4 w-4',
      base: 'h-8 w-8',
      lg: 'h-12 w-12'
    }[this.size];

    return `${baseClasses} ${sizeClasses}`;
  }
}
